import { FunctionDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const RegisterLookup = () => (
  <FunctionDocs entry="registerLookup">
    <ComponentExample
      name="Register lookup"
      rawImport={import(
        "examples/Lookups/RegisterLookup/RegisterLookupExample?raw"
      )}
    />
    <ComponentExample
      name="Data transform"
      rawImport={import(
        "examples/Lookups/RegisterLookup/DataTransformExample?raw"
      )}
    />
    <ComponentExample
      name="Lookup caching"
      rawImport={import(
        "examples/Lookups/RegisterLookup/LookupCachingExample?raw"
      )}
    />
  </FunctionDocs>
);

export default RegisterLookup;
